module.exports = __webpack_public_path__ + "assets/img/marriage-form-bg2.18bac5e8.png";